const Currency: { [propName: string]: string } = {
    '&yen;': '¥',
    '￥': '￥',
    CNY: 'CNY',
    THB: 'THB',
    USD: 'USD',
    HKD: 'HKD'
};
export default Currency;
